/* jshint ignore:start */
var lang = (navigator.languages) ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
if(lang === 'no')
	lang = 'nb';

module.exports = lang;
/* jshint ignore:end */
